import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getVoting, submitQuiz } from '../../redux/data/dataActions';
import { setPhoneNumber, setTermsAndConditions, setQuizUserSelection, setQuizSubmissionError, setQuizSubmissionSuccess } from '../../redux/data/dataSlice';
import "../../assets/css/voting.css";
import DeniedIcon from "../../assets/images/denied.svg";
import SuccessIcon from "../../assets/images/success.svg";
import InfoIcon from "../../assets/images/info.svg";
import CloseImage from "../../assets/images/close.svg";
import config from "../../config/memberhubContents.json";
import QuizFooter from "./quizFooter";
import QuizQuestions from "./quizQuestions";

function QuizModal(props) {
    const dispatch = useDispatch();
    const isMobileView = useSelector(state => state.data.isMobileView);
    const userSelections = useSelector(state => state.data.quizUserSelections);
    const quizCompleted = useSelector(state => state.data.quizSubmissionSuccess);
    const quizSubmissionError = useSelector(state => state.data.quizSubmissionError);
    const quiz = props && props.quiz;
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [quizSuccess, setQuizSuccess] = useState(false);
    const [quizError, setQuizError] = useState("");
    const [quizGrade, setQuizGrade] = useState(null);
    const [quizGradeText, setQuizGradeText] = useState("");

    const quizTaken = props && props.quiz && props.quiz.response;
    const takenQuizSelections = quizTaken && quizTaken.data && quizTaken.data.quiz_response;
    const questions = quiz && quiz.questions;
    const singleQuestion = quiz && quiz.questions && quiz.questions.length === 1;
    const rectangularImgs = quiz && quiz.extra_data && quiz.extra_data.image_size
        && quiz.extra_data.image_size === "1";
    const enabled = userSelections[currentQuestionIndex] &&
        userSelections[currentQuestionIndex].selected_answers &&
        userSelections[currentQuestionIndex].selected_answers.length > 0;
    const styles = `modal-body modal-quiz-body${singleQuestion ? ' no-progress-bar' :
        ''}${quizSuccess || quizCompleted ? ' quiz-results' : ''}`;

    const submitUserSelections = () => {
        if (userSelections === [] || userSelections.length !== questions.length) {
            setQuizSuccess(false);
            setQuizError(config.quizSubmissionErrorNoSelection);
            return;
        }

        setQuizError(null);
        const payload = {
            activity_id: props.quiz.id,
            quiz_response: userSelections,
        };
        dispatch(submitQuiz(payload));
        getGrades(quiz.questions, userSelections);
        scrollView();
    };

    const getGrades = useCallback((questions, selections) => {
        let corrects = 0;
        questions.forEach((q, index) => {
            let correctAnswer = q.correct_answer;
            let selected;

            switch (q.question_type) {
                case "select_one":
                    selected = selections[index].selected_answers[0];
                    if (selected === correctAnswer) {
                        corrects++;
                    }
                    break;

                case "select_multiple":
                    let compare = (a, b) => a - b;
                    let correctArray = correctAnswer.toSorted(compare)
                    selected = selections[index].selected_answers.toSorted(compare);
                    if (JSON.stringify(selected) === JSON.stringify(correctArray)) {
                        corrects++;
                    }
                    break;

                default:
                    break;
            }
        });

        let txt = `You answered ${corrects} out of ${quiz.questions.length} correct.`;
        let grade = (corrects / quiz.questions.length) * 100;
        setQuizGrade(grade);
        setQuizGradeText(txt);
    }, [quiz.questions]);

    const nextQuestion = () => {
        if (!enabled) {
            setQuizSuccess(false);
            setQuizError(config.quizSubmissionErrorNoSelection);
            return;
        }
        scrollView();
        setQuizError(null);
        setQuizSuccess(true);
        setCurrentQuestionIndex(currentQuestionIndex + 1);
    };

    const prevQuestion = () => {
        document.querySelector('.modal-body').click();
        document.querySelector('.modal-button-cta').blur();
        // ^ simulates click to reset Next button state on iPhone
        scrollView();
        setQuizError(null);
        setCurrentQuestionIndex(currentQuestionIndex - 1);
    }

    const scrollView = () => {
        const body = document.querySelector('.modal-body');
        body.scrollTo(0, 0);
    };

    useEffect(() => {
        if (quizTaken && takenQuizSelections) {
            getGrades(quiz.questions, takenQuizSelections);
            dispatch(setQuizUserSelection(takenQuizSelections));
            dispatch(setQuizSubmissionSuccess(true));
        }
    }, [quiz, quizTaken, takenQuizSelections, getGrades, dispatch]);

    return (
        <>
            <div className="modal-header">
                <Link
                    to={{ pathname: "/voting", search: window.location.search }}
                    className="modal-close"
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="voting"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getVoting());
                        dispatch(setPhoneNumber(""));
                        dispatch(setTermsAndConditions(false));
                        dispatch(setQuizUserSelection([]));
                        dispatch(setQuizSubmissionSuccess(false));
                        dispatch(setQuizSubmissionError(null));
                        setQuizSuccess(false);
                        setQuizError("");
                    }}>
                    <img alt="close" src={CloseImage} />
                </Link>
            </div>
            <div className="modal-header-title">
                {quiz.title}
            </div>
            <div className="modal-header-subtitle">
                {quiz.description}
            </div>
            <div className="modal-header-separator"></div>
            {quizCompleted && quizGrade !== null &&
                <div className="modal-success" style={{ marginBottom: '40px' }}>
                    <img src={SuccessIcon} alt="Success" style={{ width: '20px', height: '20px' }} />
                    <div className="review-text">
                        <span className="review-header">
                            {`${quizGrade}%, ${quizGrade === 100 ? config.quizGrade100 :
                                    quizGrade > 74 ? config.quizGrade75To99 :
                                        quizGrade > 49 ? config.quizGrade50To74 : config.quizGrade0To49
                                }`}
                        </span>
                        <span className="review-body">{quizGradeText}</span>
                    </div>
                </div>
            }
            {quizSubmissionError &&
                <div className="modal-error">
                    <img src={DeniedIcon} alt="Error" style={{ width: '20px', height: '20px' }} />
                    {quizSubmissionError}
                </div>
            }{quizError &&
                <div className="modal-error">
                    <img src={DeniedIcon} alt="Error" style={{ width: '20px', height: '20px' }} />
                    {quizError}
                </div>
            }
            {currentQuestionIndex === questions.length && !quizCompleted && !quizError && !quizSubmissionError &&
                <div className="modal-review">
                    <img src={InfoIcon} alt="Info" style={{ width: '20px', height: '20px' }} />
                    <div className="review-text">
                        <span className="review-header" >{config.quizReviewHeaderText}</span>
                        <span className="review-body">{config.quizReviewBodyText}</span>
                    </div>
                </div>
            }
            <div className={styles}>
                <QuizQuestions questions={questions} current={currentQuestionIndex} setQuizError={setQuizError}
                    rectangularImgs={rectangularImgs} isMobileView={isMobileView} />
            </div>
            <QuizFooter questions={questions} current={currentQuestionIndex} disabled={!enabled}
                next={nextQuestion} back={prevQuestion} submit={submitUserSelections} />
        </>
    );
}

export default QuizModal;
